import type {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
  ProtectedResourceScopes,
} from '@azure/msal-angular';
import type { IPublicClientApplication } from '@azure/msal-browser';
import { BrowserCacheLocation, InteractionType, PublicClientApplication } from '@azure/msal-browser';

import { inject } from '@angular/core';

import { APP_CONFIG } from '@services/app-config.token';

export function MSALInstanceFactory(): IPublicClientApplication {
  const config = inject(APP_CONFIG);

  return new PublicClientApplication({
    auth: {
      clientId: config.ClientId,
      authority: `https://login.microsoftonline.com/${config.Tenant}`,
      redirectUri: config.AdminAppUrl,
      postLogoutRedirectUri: config.AdminAppUrl,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      allowRedirectInIframe: true,
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const config = inject(APP_CONFIG);
  const protectedResourceMap = new Map<string, (string | ProtectedResourceScopes)[] | null>();

  config.MSALScopes.forEach(({ Url, Permissions }) => {
    protectedResourceMap.set(Url, Permissions);
  });

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    strictMatching: false,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}
